import { MetricGroup } from '@appcues/sonar';
import styled from 'styled-components';

export const AnalyticsMetricGroup = styled(MetricGroup)`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(${({ columns = 4 }) => columns}, 1fr);
`;
